/* eslint-disable  */
import React, { useMemo, useState } from 'react';
import {
    Typography, Button, Dialog, DialogContent, Grid, Tooltip, 
    IconButton, Menu, MenuItem } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { DataGrid } from '@mui/x-data-grid';
import Form from './Form';
import Swal from '#/swal';
import {
    useCreateDepartment, useDeleteDepartment, useDepartments, useUpdateDepartment
} from '~/departments';
import { Delete, Edit, People, MoreVert } from '@material-ui/icons';



const useStyles = makeStyles({
    dataGrid: {
        '&.MuiDataGrid-root .MuiDataGrid-columnHeader:focus, &.MuiDataGrid-root .MuiDataGrid-cell:focus': {
            outline: 'none'
        }
    },
    tableWrapper: {
        width: '100%'
    },
    redButton: {
        color: '#fff',
        backgroundColor: '#DB2828'
    }
});


const ListDepartments = props => {
    


    const classes = useStyles();
    const { data: departments, isLoading } = useDepartments();
    const { mutate: deleteDepartment } = useDeleteDepartment();
    const { mutate: updateDepartment} = useUpdateDepartment();
    const { mutate: createDepartment} = useCreateDepartment();

    const [initialValues, setInitialValues] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [actions, setActions] = useState(null);
    const [rowSelected, setRowSelected]=useState();
 
    const onSubmit = values => {
        if (initialValues) {
            updateDepartment({
                id: values.id,
                payload: values
            });
        }
        else {
            createDepartment(values);
        }
        setModalOpen(false);
    };

    const handleDelete = async department => {
        const { value } = await Swal.fire.warning({ text: `Are you sure you want to delete ${department.name}` });

        if (value) deleteDepartment(department.id);
    };

    // Popover settings.

        const openPopover = (event, row) => {

            // console.log(????, row)
            setRowSelected(row)
            setActions(event.currentTarget);
        };

        const closePopover = () => {
            setActions(null);
        };
        const moreActions = Boolean(actions);


    const columns = useMemo(() => [
        
        {
            field: 'name',
            renderHeader: () => <strong>Name</strong>,
            flex: 1,
            renderCell: ({ row }) => {
                return <div> {row.name} </div>
         }
        },
        {
            field: 'id',
            align: 'right',
            headerAlign: 'right',
            renderHeader: () => <strong>Actions</strong>,
            renderCell: ({ row }) => (
                <div>
                        <IconButton
                            onClick= {(e) => openPopover(e, row)}> 
                            <MoreVert />
                        </IconButton>
                </div>
            ),
            flex: .2
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ], []);


    return (
        <div>
            <Grid container justifyContent='space-between' style={{ marginBottom: '20px', marginTop: '20px' }}>

                <Grid item>
                    <Typography variant='h4' children='Departments' />
                </Grid>

                <Grid item>
                    <Button
                        children='New Department'
                        variant='contained'
                        color='primary'
                        onClick={() => {
                            setInitialValues(null);
                            setModalOpen(true);
                        }}
                    />

                </Grid>

            </Grid>

            <div className={classes.tableWrapper}>

                <DataGrid
                    className={classes.dataGrid}
                    loading={isLoading}
                    columns={columns}
                    rows={departments || []}
                    autoHeight
                    disableSelectionOnClick
                    hideFooterSelectedRowCount
                />
                 <div>
                    <Menu
                        id='actions'
                        open={moreActions}
                        anchorEl={actions}
                        onClose={closePopover} 
                        onClickCapture={closePopover}
                    >
                        <MenuItem onClick={() => {
                                setInitialValues(rowSelected);
                                setModalOpen(true);
                            }}>
                            Edit
                        </MenuItem>
                        <MenuItem onClick={ () => handleDelete(rowSelected) }>
                            Delete
                        </MenuItem>
                        <MenuItem onClick={() => props.history.push(`/departments/${rowSelected.id}/employees`)}>
                            View Employees
                        </MenuItem>
                    </Menu>
                </div>
            
            </div>

            <Dialog open={modalOpen} onClose={() => setModalOpen(false)}>
                <DialogContent>
                    <Form setModalOpen={setModalOpen} initialValues={initialValues} onSubmit={onSubmit}/>
                </DialogContent>
            </Dialog>

        </div>
    );
};


export default ListDepartments;

